<ng-container *ngIf="kkm">
  <button
    *ngIf="kkm.availableOperations?.selectTariff"
    class="button_blue"
    data-qa-link="kkm-tariffs"
    (click)="goToSelectSubscriptionPage(kkm.id)"
  >
    {{ 'kkm.status.select.tariff' | translate }}
  </button>
  <button
    *ngIf="kkm.availableOperations?.activateTariff"
    class="button_blue"
    data-qa-button="activate-tariff"
    [taxOpenActivateSubscriptionModal]="(activateSubscriptionModalInputData$ | async) ?? undefined"
    (subscriptionActivated)="updateKkmData()"
  >
    {{ 'kkm.status.activate.tariff' | translate }}
  </button>
</ng-container>
